import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useRef, useState } from "react";
import MySignaturePad from "./MySignaturePad";

export default function SignItem({ onChange }) {
    const signRef = useRef();
    const [open, setOpen] = useState(false);

    return (
        <div>
            {!signRef.current?.getValue() && <Button onClick={() => setOpen(true)}>Firma</Button>}
            {signRef.current?.getValue() && <img src={signRef.current.getValue()} height={100} />}
            {signRef.current?.getValue() && (
                <DeleteOutlined
                    onClick={() => {
                        signRef.current.clear();
                        onChange?.();
                    }}
                />
            )}
            <Modal
                open={open}
                title={"Firma"}
                width={500}
                onOk={() => {
                    if (signRef.current.getValue()) {
                        onChange?.(signRef.current.getValue());
                        setOpen(false);
                    }
                }}
                onCancel={() => setOpen(false)}
                maskClosable={false}
                destroyOnClose
            >
                <MySignaturePad width={400} height={200} ref={signRef} />
            </Modal>
        </div>
    );
}
